<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">Ajouter un participant</h4>
    </div>
    <div class="modal-body">
      <div class="row"
           style="margin-bottom: 20px;">
        <div class="col-sm-12">
          <h4>Nom du participant</h4>
          <input type="text"
                 placeholder="Nom du participant"
                 class="form-control"
                 v-model="participant.name">
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <h4>Titre du participant</h4>
          <input type="text"
                 id="search"
                 name="search"
                 placeholder="Titre du participant ..."
                 class="form-control"
                 v-model="participant.title">
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-center">
      <button type="button"
              class="btn btn-default"
              @click="closeModal">Annuler</button>
      <button type="button"
              class="btn btn-primary"
              :disabled="!participant.name || !participant.title"
              @click="onSubmit">Ajouter</button>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'

  export default {
    data: () => ({
      store,
      participant: {
        name: '',
        title: ''
      }
    }),

    computed: {
      model () {
        return store.modal.dataModel
      }
    },

    methods: {
      onSubmit () {
        this.$bus.$emit('add-participant', this.participant)
        this.closeModal()
      }
    }
  }
</script>
